import Image from '@/components/UI/Image';
import EFDelta2ActiveIcon1 from '@/components/UI/svg/Delta2/Icon/EFDelta2ActiveIcon1';
import EFDelta2ActiveIcon2 from '@/components/UI/svg/Delta2/Icon/EFDelta2ActiveIcon2';
import EFDelta2ActiveIcon3 from '@/components/UI/svg/Delta2/Icon/EFDelta2ActiveIcon3';
import EFDelta2ActiveIcon4 from '@/components/UI/svg/Delta2/Icon/EFDelta2ActiveIcon4';
import EFArrowRightUpNew from '@/components/UI/svg/Icons/EFArrowRightUpNew';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
interface ShopifyUrl {
    [key: string]: string;
}
const shopifyUrlMap: ShopifyUrl = {
    us: '/us/delta-2-portable-power-station',
    ca: '/ca/delta-2-portable-power-station',
    uk: '/uk/delta-2-portable-power-station',
    de: '/de/delta-2-portable-power-station',
    fr: '/fr/delta-2-portable-power-station',
    it: 'https://it.ecoflow.com/products/delta-2-portable-power-station',
    es: 'https://es.ecoflow.com/products/delta-2-portable-power-station',
};

export default function Delta2Group3() {
    const { Link, useLang, useRouter, gtm } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    const { t } = useLang('delta2portablepowerstationevent');

    const data = [
        {
            icon: <EFDelta2ActiveIcon1 />,
            tip: t('group4-glance-1-tip'),
            text: t('group4-glance-1'),
        },
        {
            icon: <EFDelta2ActiveIcon2 />,
            tip: t('group4-glance-2-tip'),
            text: t('group4-glance-2'),
        },
        {
            icon: <EFDelta2ActiveIcon3 />,
            tip: t('group4-glance-3-tip'),
            text: t('group4-glance-3'),
        },
        {
            icon: <EFDelta2ActiveIcon4 />,
            tip: t('group4-glance-4-tip'),
            text: t('group4-glance-4'),
        },
    ];

    const list = data.map((item, i) => (
        <li key={i} className="item">
            <div className="line1">
                <span className="icon">{item.icon}</span>
            </div>
            <div className="line2">
                <p className="tip">{item.tip}</p>
                <p className="des">{item.text}</p>
            </div>
        </li>
    ));

    const clickDiscover = () => {
        window?.fbq('track', 'Contact');
        gtm.push({
            event: 'uaEvent',
            event_name: 'discover_product',
            product_name: 'DELTA2',
            button_name: t('group4-discover'),
        });
    };

    return (
        <div className={css.delta2_group4}>
            <div className="top">
                <h5 className="group4-title">{t('group4-title')}</h5>
                <div className="discover-container" onClick={clickDiscover}>
                    <Link href={shopifyUrlMap[locale]}>
                        {t('group4-discover')}
                        <span>
                            <EFArrowRightUpNew width="0.17rem" height="0.17rem" />
                        </span>
                    </Link>
                </div>
            </div>

            <div className="bottom">
                <div className="left-img">
                    <Image src="/img/delta2Activilypage/delta2_left_main.png" layout="fill" alt="" />
                </div>
                <ul className="right-content">{list}</ul>
            </div>
        </div>
    );
}
